import { GetterTree } from 'vuex'
import UserProfileState from './states'
import { State } from '@/store/store'
import _ from 'lodash'

const getters: GetterTree<UserProfileState, State> = {
  getProfile: (state) => {
    return state.profile
  },
  getLine: (state) => {
    return state.line
  },
  getMetaData: (state) => {
    return state.profile[`metadata`]
  },
  permissions: (state) => {
    const permissions = {}
    _.forEach(state.profile[`permissions`], (permission) => {
      const key = `${permission.key}::${permission.level}::`
      _.forEach(permission.type, (type) => {
        permissions[key + type] = true
      })
    })
    return permissions
  },
}

export default getters
